
import { Card, CardContent } from "@/components/ui/card";
import { Package } from "lucide-react";
import { EtsyProduct } from "@/hooks/useEtsyProducts";
import ProductCard from "./ProductCard";

interface ProductGridProps {
  products: EtsyProduct[];
  isLoading: boolean;
  hasActiveFilters: boolean;
  onProductSelect: (productId: string) => void;
}

const ProductGrid = ({ 
  products, 
  isLoading, 
  hasActiveFilters, 
  onProductSelect 
}: ProductGridProps) => {
  if (isLoading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading products...</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <Card>
        <CardContent className="p-6 text-center">
          <Package className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No Products Found</h3>
          <p className="text-gray-600">
            {hasActiveFilters
              ? 'No products match your current filters. Try adjusting your search criteria.' 
              : 'No products available. Try syncing your Etsy products.'}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onProductSelect={onProductSelect}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
